import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { GiftIcon } from "lucide-react";
import { motion } from "motion/react";
import { useCustomText } from "../hooks/use-custom-text";

export function GiftCompletePage() {
  const t = useCustomText();

  return (
    <WidgetPage variant="centered">
      <motion.span
        initial={{ opacity: 0, scale: 0.9, y: 5, rotate: 30 }}
        animate={{ opacity: 1, scale: 1, rotate: 0, y: 0 }}
        exit={{ opacity: 0, scale: 0.98, rotate: -10, transition: { duration: 0.25, ease: "easeIn" } }}
        transition={{ delay: 0.2, type: "spring" }}
        style={{ transformOrigin: "top left" }}
      >
        <GiftIcon className="text-success-foreground size-10 mx-auto" />
      </motion.span>
      <Header>
        <HeaderTitle>{t("gift.complete.title")}</HeaderTitle>
        <HeaderDescription>{t("gift.complete.description")}</HeaderDescription>
      </Header>
    </WidgetPage>
  );
}
